import React, { useContext, useEffect, useState } from "react";
import { SvgImages, PngImages } from "../../Utils/LocalImages";
import { Link, Routes, useLocation } from "react-router-dom";
import Image from "../../Components/Reusable/Image";
import RoutesPath from "../../Utils/RoutesPath";
import ApiConstants from "../../Utils/ApiConstant";
import { AuthContext } from "../../Context/authContext";
import { useSidebar } from "../../Context/toggleContext";

const CoordinatorSidebar = () => {
  const [activeAccordion, setActiveAccordion] = useState(-1);
  const [currentPath, setCurrentPath] = useState(0);
  const { coordinator } = useContext(AuthContext);
  const { sidebarOpen, toggleSidebar } = useSidebar();

  const location = useLocation();

  useEffect(() => {
    switch (location.pathname) {
      case RoutesPath.dashboardcoordinator:
        setActiveAccordion(1);
        break;
      case RoutesPath.withdrawlrequest:
      case RoutesPath.dashboardcoordinator:
        setActiveAccordion(2);
        break;
      case RoutesPath.transactionhistory:
        setActiveAccordion(3);
        break;
      case RoutesPath.updatebankdetails:
        setActiveAccordion(4);
        break;
      case RoutesPath.coordinatorchangepassword:
        setActiveAccordion(5);
        break;
      case RoutesPath.profile:
        setActiveAccordion(6);
        break;
      default:
        setActiveAccordion(1);
        break;
    }
    setCurrentPath(location.pathname);
  }, [location.pathname]);

  const handleLinkClick = () => {
    toggleSidebar(); // Close the sidebar when a link is clicked
  };



  return (
    <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}>
      <div className="sidebar d-flex flex-column overflow-auto ">
        <button
          className="navbar-togglercross"
          onClick={toggleSidebar}
        >
          &times;
        </button>


        <div className="cologo  mt-3 mb-5">
          <Link to={RoutesPath.dashboardcoordinator}>
            <Image
              src={PngImages.dashboardLogo}
              className="img-fluid object-fit-contain"
              alt="Logo"
              style={{ height: "60px" }}
            />
          </Link>
        </div>
        <div className="mx-3 mb-4 mt-2 student-profile-section">
          <div className=" d-flex justify-content-center select_profile_img">
            {/* <CustomTextFieldTwo id="file" type="file" className="d-none" /> */}
            <Image className="studentmodal_profile" style={{ objectFit: "cover" }} src={coordinator?.profilePicture && coordinator.profilePicture?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + coordinator.profilePicture : SvgImages.user_profile} onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = SvgImages.user_profile;
            }} />
            {/* <div className="position-relative">
                <a className="secondary fs-16 fw-500 edit_img d-flex justify-content-center align-items-center cursor-pointer" >
                  <Image src={SvgImages.profile_editng}    />
                </a>

                
              </div>
     */}

          </div>
          <div className="profile_text mb-3 text-center">
            {/* <h2>{user?.name?.trim()}</h2> */}
            <h2 className=" white medium-text fw-600 mb-2">{coordinator.name}</h2>
            <h3 className="orangeAccentColor small-text fw-600">{coordinator.referralCode}</h3>
          </div>
        </div>
        <div className="d-flex flex-column ps-3 mb-0">
          <Link to={RoutesPath.dashboardcoordinator} onClick={handleLinkClick}>
            <div
              className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 1 || activeAccordion == 2
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
                }`}
              onClick={() => {
                setActiveAccordion(1);
              }}
            >
              <div className="d-flex gap-3">
                <Image src={SvgImages.menu_icon} />
                <h1 className="white small-medium-text fw-500 mb-0" style={{ marginTop: 1 }}>
                  My Commission
                </h1>
              </div>
              <div
                className={`${activeAccordion == 2 ? "accordianArrowInvert" : "accordianArrow"
                  }`}
              />
            </div>
          </Link>

        </div>


        <div className="d-flex flex-column ps-3 mb-1">
          <div
            className={`accordion-body p-0 ms-4 ${activeAccordion == 2 ? "accordiaBodyActive" : "accordiaBodyInactive"
              }`}
          >
            <div className="selectSection select_option ">
              <Link to={RoutesPath.withdrawlrequest} onClick={handleLinkClick}>
                <h2 className="fw-500 mt-3"
                  style={{
                    color:
                      currentPath === RoutesPath.withdrawlrequest
                        ? "#F6821F"
                        : "#a8a8a8",
                  }}
                >
                  Withdrawal Request
                </h2>
              </Link>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column ps-3 mb-2">
          <Link to={RoutesPath.transactionhistory} onClick={handleLinkClick}>
            <div
              className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 3
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
                }`}
              onClick={() => {
                setActiveAccordion(3);
              }}
            > <div className="d-flex gap-3">
                <Image src={SvgImages.menu_icon} />
                <div className="d-flex gap-2 align-items-center">
                  <h1 className="white small-medium-text fw-500 mb-0" style={{ marginTop: 1, whiteSpace: "nowrap" }}>
                    Transaction History
                  </h1>
                </div>

              </div>
            </div>
          </Link>
        </div>


        <div className="d-flex flex-column ps-3 mb-2">
          <Link to={RoutesPath.updatebankdetails} onClick={handleLinkClick}>
            <div
              className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 4
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
                }`}
              onClick={() => {
                setActiveAccordion(4);
              }}
            >  <div className="d-flex gap-3">
                <Image src={SvgImages.menu_icon} />
                <h1 className="white small-medium-text fw-500 mb-0" style={{ marginTop: 1 }}>
                  Update Bank Details
                </h1>
              </div>
            </div>
          </Link>
        </div>
        <div className="d-flex flex-column ps-3 mb-2">
          <Link to={RoutesPath.coordinatorchangepassword} onClick={handleLinkClick}>
            <div
              className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 5
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
                }`}
              onClick={() => {
                setActiveAccordion(5);
              }}
            >  <div className="d-flex gap-3">
                <Image src={SvgImages.menu_icon} />
                <h1 className="white small-medium-text fw-500 mb-0" style={{ marginTop: 1 }}>
                  Change Password
                </h1>
              </div>
            </div>
          </Link>
        </div>

        <div className="d-flex flex-column ps-3 mb-2">
          <Link to={RoutesPath.profile} onClick={handleLinkClick}>
            <div
              className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 6
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
                }`}
              onClick={() => {
                setActiveAccordion(6);
              }}
            >  <div className="d-flex gap-3">
                <Image src={SvgImages.menu_icon} />
                <h1 className="white small-medium-text fw-500 mb-0" style={{ marginTop: 1 }}>
                  Profile
                </h1>
              </div>
            </div>
          </Link>
        </div>


      </div>
    </div>
  );
};

export default CoordinatorSidebar;
